<form [formGroup]="stepForm">
  <div [innerHTML]="formData.contentSelectionDescription | markdown" class="step-description"></div>
  <mat-radio-group aria-labelledby="salutation-label" formControlName="contentControl">
    <mat-radio-button
      color="primary"
      class="salutation-radio-button"
      *ngFor="let documentType of documentTypeSelectitems"
      [value]="documentType"
    >
      {{ documentType.displayValue }}
    </mat-radio-button>
  </mat-radio-group>
  <div [innerHTML]="infoPageDescription | markdown" class="step-description" [class.disabled]="infoPageDisabled"></div>
  <mat-form-field>
    <mat-label>{{ formData.infoPageControlLabel }}</mat-label>
    <mat-select formControlName="infoPageControl">
      @for (infoPage of infoPageSelectItems; track infoPage.key) {
        <mat-option [value]="infoPage">{{ infoPage.displayValue }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div *ngIf="brand">
    <mat-form-field>
      <mat-label>Brand</mat-label>
      <mat-select formControlName="brandControl">
        @for (brand of brandValues; track brand.key) {
          <mat-option [value]="brand">{{ brand.displayValue }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <button mat-stroked-button matStepperPrevious>{{ formData.buttonLabelBack }}</button>
    <button mat-stroked-button matStepperNext [disabled]="!stepForm.valid">{{ formData.buttonLabelNext }}</button>
  </div>
</form>
